import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { BpmnEditorViewModel } from "./bpmnEditor/bpmnEditor-viewModel";
import { IEditorPart, ProcessDefinitionViewModel, singleProcess } from "./processDefinition-viewModel"

export class ProcessDefinitionView extends View<ProcessDefinitionViewModel>{
    GetViewUniqueId(): string {
        return "V-E9EFF16D-99FE-4DEC-84E3-FF67E3C04BED"
    }
    loadHtml(): string {
        let element = require('./processDefinition.html').default;
        let style = require('./processDefinition.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set processes(v: ObservableArray<singleProcess>) { this._processes = v; } public get processes(): ObservableArray<singleProcess> { return this._processes;} private _processes: ObservableArray<singleProcess>;
    public set selectedProcess(v: singleProcess) { this._selectedProcess = v; } public get selectedProcess(): singleProcess { return this._selectedProcess;} private _selectedProcess: singleProcess;
    public set newProcessName(v: string) { this._newProcessName = v; } public get newProcessName(): string { return this._newProcessName;} private _newProcessName: string;
    
    public set processDefinitionParts(v: ObservableArray<IEditorPart>) { this._processDefinitionParts = v; } public get processDefinitionParts(): ObservableArray<IEditorPart> { return this._processDefinitionParts;} private _processDefinitionParts: ObservableArray<IEditorPart>;
    public set selectedDefinitionPart(v: IEditorPart) { this._selectedDefinitionPart = v; } public get selectedDefinitionPart(): IEditorPart { return this._selectedDefinitionPart;} private _selectedDefinitionPart: IEditorPart;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    
    async createNewProcess(){
        this.dataContext.createNewProcess();
    }

    async updateProcessName(){
        this.dataContext.updateProcessName();
    }
    async deleteProcess(){
        this.dataContext.deleteProcess();
    }
}
